// extracted by mini-css-extract-plugin
module.exports = {"timeLabel":"c6e8ba5398--timeLabel--2uqKQ","relative":"c6e8ba5398--relative--1cJgU","absolute":"c6e8ba5398--absolute--9uFLj"};